export const TAPUME_FLAG = 'tapume';
export const HAS_SEGMENTATION_FLAG = 'hassegmentation';
export const SCRIPT_CLEAR_SALE = 'scriptclearsale';
export const LOYALTY_INCENTIVE_CAMPAIGN = 'loyaltyIncentiveCampaign';
export const LOYALTY_INCENTIVE_NAV_BAR = 'loyaltyIncentiveCampaignNavBar';
export const NOTIFICATION_MULTBRAND_LOGIN = 'notificationToMultibrandLogin';
export const SCRIPT_VWO_TEST_AB = 'scripttestabvwo';
export const SHOW_CYCLE_GUIDE = 'showCycleGuide';
export const IS_HYBRID_CART_ACTIVE = 'ishybridcartactive';
export const PIX_PAYMENT_FLAG = 'pixPayment';
export const SEND_PDP_FLAG = 'sendPdpFlag';
export const SHOW_SALES_MANAGEMENT = 'showsalesmanagement';
export const BADGE_PIX_NAME = 'badge_pix_name';
export const SHOW_PIX_BADGE = 'showpixbadge';
export const NEW_PAYMENT_FLOW = 'newpaymentflow';

export type Flags =
  | typeof HAS_SEGMENTATION_FLAG
  | typeof IS_HYBRID_CART_ACTIVE
  | typeof LOYALTY_INCENTIVE_CAMPAIGN
  | typeof NOTIFICATION_MULTBRAND_LOGIN
  | typeof PIX_PAYMENT_FLAG
  | typeof SCRIPT_CLEAR_SALE
  | typeof SCRIPT_VWO_TEST_AB
  | typeof SEND_PDP_FLAG
  | typeof SHOW_CYCLE_GUIDE
  | typeof TAPUME_FLAG
  | typeof SHOW_SALES_MANAGEMENT
  | typeof BADGE_PIX_NAME
  | typeof SHOW_PIX_BADGE
  | typeof NEW_PAYMENT_FLOW;
